export const MelatechSupportEmail = 'support@melatech.io';
/** Recipient for developer-facing alerts: integration failures and data defects the team must fix. */
export const MelatechIntegrationsEmail = 'integrations@melatech.io';
export const MelatechDkSupportPhone = '+4544408245';
